import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import EmanuelPressPage from './pages/press/emanuelpage';
import AnalyticsGate from './components/AnalyticsGate';
import NotFoundPage from './pages/notfound/page';
import { SECTION_PATHS } from './constants/site';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AnalyticsGate>
      <BrowserRouter>
        <Routes>
          {/* Regular route for the /press page */}
          <Route path="/pressmeddelanden/emanuel-lipschutz-styrelseordforande-acebit" element={<EmanuelPressPage />} />
          {/* Startsidan och alla sektioner: en och samma sida, App scrollar till rätt sektion utifrån URL:en */}
          {Object.values(SECTION_PATHS).map((path) => (
            <Route key={path} path={path} element={<App />} />
          ))}
          {/* Catch-all 404 for any other path */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </AnalyticsGate>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();